import loader from './loader';

const Component = () => import('./Storefront');

export { Component, loader };
